import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import airline from "../Images/airline.gif";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";
import "../Style/publicpages.css";

export default function Aerospace() {
  return (
    <>
      <SEO
        title="AI ERP & CRM for Aerospace Industry"
        description="Streamline aerospace manufacturing, supply chain tracking, and defense compliance with EnteliPro AI ERP software and intelligent CRM solutions."
        keywords="Aerospace ERP Software, AI ERP for Aviation, Aerospace CRM Solutions, Defense Supply Chain ERP, Aviation Business Management"
        canonical="https://www.entelipro.com/Aerospace"
        ogImage="https://www.entelipro.com/static/media/airline.gif"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Aerospace Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 aerospace-gap-fix-top">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={airline}
                  alt="EnteliPro AI ERP for Aerospace and Defense Industry"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1
                  className="header-name"
                  style={{
                    fontSize: "2.3rem",
                    fontWeight: "700",
                    marginBottom: "1rem",
                  }}
                >
                  AI ERP Software for Aerospace Industry
                </h1>
                <p className="para">
                  Aerospace organizations research, design, manufacture, operate
                  or maintain aircraft or spacecraft. Aerospace activity is very
                  diverse, with a multitude of commercial, industrial, and
                  military applications. EnteliPro provides intelligent ERP
                  solutions to manage these rigorous workflows.
                </p>
                <div className="jst-two-coloums">
                  <div className="icon-text">
                    <p className="para">
                      The aerospace industry is a cooperation of the public and
                      private sectors requiring seamless data synchronization.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      Aerospace is a constantly evolving market that requires
                      its players to take advantage of the latest AI tools and
                      automated practices to meet stringent regulatory standards.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies aerospace-gap-fix-bottom">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>ERP for Aerospace Industry</h3>
              <p className="para">
                Aerospace companies recognize the importance of AI ERP systems
                when it comes to improving sales effectiveness, delivering
                superior customer service, improving product accuracy, and
                maximizing employee productivity. EnteliPro satisfies the
                complex demands of aerospace and defense enterprises.
              </p>

              <p className="para">
                Aerospace contracts are characterized by their complexity and
                wide-ranging scope. A Cloud ERP solution in this environment
                addresses the critical need for security, traceability, and
                regulatory compliance.
              </p>

              <h3 className="benefits-heading">
                Benefits of {project_name} for Aerospace Industry
              </h3>
            </div>

            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Enterprise Traceability</h4>
                  <p className="para">
                    Maintain end-to-end component traceability and regulatory
                    audit readiness across complex assembly pipelines.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Streamlined Deal Management</h4>
                  <p className="para ">
                    Enable sales and contract teams to spend more time
                    connecting with clients and negotiating agreements rather
                    than compiling manual reports.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Predictive Maintenance</h4>
                  <p className="para">
                    Leverage predictive AI analytics to anticipate component
                    service lifecycles and avoid costly flight or assembly
                    delays.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}